import React, { useEffect } from 'react'
import TopRightLink from '../../../components/atoms/formFields/buttons/topRightLink'
import CardWrapper from '../../../components/molecules/CardWrapper'
import CardHeader from '../../../components/atoms/cardHeader'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { GetVendorProductDetails } from '../../../store/thunks/productThunk'
import { Carousel, Col, Modal, Row } from 'antd'
import media from '../../../media'
import moment from 'moment'
import htmlToFormattedText from "html-to-formatted-text";

const SellerVerification = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { data: detail } = useSelector((state) => state?.vendorProductDetails);

    useEffect(() => {
        dispatch(GetVendorProductDetails({ productId: id }));
    }, [dispatch])

    return (
        <div className="content d-flex flex-column flex-column-fluid">
            <div className="container">
                <div className="align-items-center d-flex justify-content-end pb-6">
                    <TopRightLink
                        url="/trackApprovalRequests"
                        name="Track Approval Requests"
                    />
                </div>
            </div>

            <CardWrapper>
                <CardHeader name={"Verification Status"} tooltipText={"View the status and details of your submitted product verification or approval request."}/>
                <div className="card-body p-4">
                    <div className="card card-custom mb-10">
                        <div className="border border-1 border-light-dark card-body radius ribbon ribbon-clip ribbon-right">
                            {/****Seller Details Start******/}
                            <div className="flex-grow-1">
                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    <div className="mb-0 w-100">
                                        <div className="d-flex flex-lg-column float-lg-left justify-content-between my-1 w-100 w-lg-25">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                Seller ID :
                                            </span>
                                            <span className="ml-lg-1 text-muted">
                                                {detail?.sellerId}
                                            </span>
                                        </div>
                                        <div className="d-flex flex-lg-column float-lg-left justify-content-between my-1 w-100 w-lg-25">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                Seller Name :
                                            </span>
                                            <span className="ml-lg-1 text-muted">
                                                {detail?.sellerName?.en}
                                            </span>
                                        </div>
                                        <div className="d-flex flex-lg-column float-lg-left justify-content-between my-1 w-100 w-lg-25">
                                            <span className="text-dark-75 font-weight-bolder mr-2">
                                                Request Received on :
                                            </span>
                                            <span className="ml-lg-1 text-muted">
                                                {moment
                                                    .utc(detail?.createdDate)
                                                    .local()
                                                    .format("DD/MM/YYYY hh:mm A")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/****Seller Details Start******/}
                        </div>
                    </div>

                    <Row gutter={[12, 12]} className="m-0">
                        <Col xs={24} lg={17}>
                            <div className="p-0 pr-lg-7">
                                <div className="overflow-hidden product_type">
                                    <div className="align-items-center">
                                        <h5 className="font-weight-bolder mb-2">
                                            Product Name
                                        </h5>
                                        <span className="font-size-md ml-lg-5 text-muted d-block">
                                            {detail?.name}
                                        </span>
                                    </div>
                                </div>
                                <div className="separator separator-solid my-5"></div>

                                <div className="overflow-hidden product_type">
                                    <h5 className="font-weight-bolder mb-2">
                                        Product Details
                                    </h5>
                                    <div className="align-items-center d-flex float-lg-left my-1 w-100 ml-lg-5">
                                        <span className="font-size-lg font-weight-bolder m-0">
                                            Brand Name :
                                        </span>
                                        <span className="font-size-md ml-5 text-muted">
                                            {detail?.productDetails?.brandName}
                                        </span>
                                    </div>
                                    <div className="align-items-center d-flex float-lg-left my-3 w-100 ml-lg-5">
                                        <span className="font-size-lg font-weight-bolder m-0">
                                            Brand Logo :
                                        </span>
                                        <img
                                            src={
                                                detail?.productDetails?.brandLogo
                                                    ? detail?.productDetails?.brandLogo
                                                    : media.ak_logo
                                            }
                                            alt="Brand Logo"
                                            className=" ml-5 max-w-100px"
                                        />
                                    </div>
                                </div>
                                <div className="separator separator-solid my-5"></div>

                                <div className="about_p">
                                    <h5 className="font-weight-bolder mb-2">
                                        About Product
                                    </h5>
                                    <p className="font-size-base font-weight-bold letter-spacing text-dark-75 max-w-900px">
                                        {htmlToFormattedText(detail?.description)}
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col xs={24} lg={7}>
                            <div className="verifi-slider">
                                <Carousel showIndicators={false} showThumbs={false}>
                                    {detail?.imageLinks?.map((image, index) => {
                                        return (
                                            <div key={index.toString()}>
                                                <img alt="img" src={image} />
                                            </div>
                                        );
                                    })}
                                </Carousel>
                            </div>
                        </Col>
                    </Row>

                    <div className="separator separator-solid my-5"></div>
                    <div className="mb-5 mr-5 text-lg-right text-center">
                        <button
                            type="button"
                            className={`all_bottom_buttons ${detail?.status === "REJECTED"
                                ? "bg-danger"
                                : detail?.status === "APPROVED"
                                    ? "bg-primary"
                                    : "bg-warning"
                                }`}
                        >
                            {detail?.status}
                        </button>
                    </div>
                </div>
            </CardWrapper>

            {/**Decline Modal Start*/}
            <Modal
                title="Decline Reason"
                centered
                // visible={modal2Visible}
                // onCancel={() => setModal2Visible(false)}
                footer={null}
                className="decline"
            >
                <div className="reason_text">
                    <form className="text-center">
                        <textarea
                            className="form-control h-50"
                            rows="3"
                            // onChange={(e) => {
                            //     setRemarks({
                            //         declined: e.target.value,
                            //     });
                            // }}
                        ></textarea>
                        <button
                            type="button"
                            className="all_bottom_buttons mt-5"
                            // onClick={(e) => {
                            //     e.preventDefault();
                            //     approveOrDecline("REJECTED", remarks?.declined);
                            // }}
                        >
                            Send
                        </button>
                    </form>
                </div>
            </Modal>
            {/**Decline Modal End*/}
        </div>
    )
}

export default SellerVerification